import { useEffect } from 'react';
import { Text } from '@chakra-ui/react';

import { usePaginateDashboards, useDashboards } from 'hooks/customDashboards';
import { useFilters } from 'hooks/filters';

import AsyncTable from 'components/Tables/AsyncTable';
import dateFormat from 'functions/dateFormat';

const columns = [
	{
		Header: 'Nome',
		accessor: 'name'
	},
	{
		Header: 'Total de Gráficos',
		accessor: 'charts',
		Cell: ({ value }) => <Text>{value?.length}</Text>
	},
	{
		Header: 'Data de criação',
		accessor: 'created_at',
		Cell: ({ value }) => <Text>{dateFormat(value)}</Text>
	}
];

const DashboardsTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useDashboards();
	const [paginateDashboards, { loading }] = usePaginateDashboards();

	const deleteDashboard = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateDashboards({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateDashboards({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="custom-dashboards"
			removeAction={deleteDashboard}
			linkRow
		/>
	);
};

export default DashboardsTable;
